import React, {useState, useEffect} from 'react';
import {Button, Spinner} from 'reactstrap';
import {textTruncateByLength, numberWithCommas} from 'utils/other';
import Article from './Article';
import {toast} from 'react-toastify';
import {updateSourceIsOpen} from 'utils/api';

const SourceBlock = ({activeEntityId, source, sentimentFilters, setEntityNews, fullSearchResults}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [visibleNews, setVisibleNews] = useState(false);
    const [visibleArticleRange, setVisibleArticleRange] = useState(5);

    const toggleIsOpen = () => setIsOpen(prevState => !prevState);

    useEffect(() => {
        setIsOpen(source.isOpen);
        if(source.news) {
            // let filteredBySentimentList = filterBySentiment(source.news);
            setVisibleArticleRange(5);
            setVisibleNews(source.news);
        }
    }, [sentimentFilters, source.isOpen]);

    // const filterBySentiment = (arr) => {
    //     let allowedSentiments = [];
    //     sentimentFilters.negative && allowedSentiments.push(-1);
    //     sentimentFilters.neutral && allowedSentiments.push(0);
    //     sentimentFilters.positive && allowedSentiments.push(1);
    //     return arr.filter(item => {
    //         return allowedSentiments.includes(item.sentiment);
    //     });
    // };

    const getSourceIcon = (sourceType) => {
        switch(sourceType) {
            case 'twitter':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#1DA1F2'}}>
                        <i className="fab fa-twitter"/>
                    </div>
                );
            case 'facebook':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#4267B2'}}>
                        <i className="fab fa-facebook-f"/>
                    </div>
                );
            case 'youtube':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#FF0000'}}>
                        <i className="fab fa-youtube"/>
                    </div>
                );
            case 'instagram':
                return (
                    <div className="adding-media-icon filter-icon--instagram">
                        <i className="fab fa-instagram"/>
                    </div>
                );
            case 'rss':
                return (
                    <div className="adding-media-icon" style={{backgroundColor: '#ee802f'}}>
                        <i className="fas fa-rss"/>
                    </div>
                );
            case 'google_ozmosys':
                return (
                    <div className="adding-media-icon"
                         style={{backgroundColor: 'none', color: '#314784', fontSize: '50px'}}>
                        <i className="fa fa-globe"/>
                    </div>
                );
            case 'web':
                return (
                    <div className="adding-media-icon"
                         style={{backgroundColor: 'none', color: '#6E7179', fontSize: '50px'}}>
                        <i className="fa fa-cog"/>
                    </div>
                );
            default:
                return false;
        }
    };

    const handleInfluenceDisplay = () => {
        if(!source.hasOwnProperty('influence')) return null;
        if(source.type === 'web' || source.type === 'rss' || source.type === 'google_ozmosys') return null;
        if(source.type === 'twitter') {
            if(source.pageId === null || source.twitterPageId === null) return null;
        }
        return (
            <div>&nbsp;{`(${numberWithCommas(source.influence)} ${handleInfluenceSuffix(source.influence)})`}</div>
        )
    }

    const handleInfluenceSuffix = (influence) => {
        switch(source.type) {
            case 'twitter':
                return influence === 1 ? 'Follower' : 'Followers';
            case 'facebook':
                return influence === 1 ? 'person likes this' : 'people like this';
            case 'youtube':
                return influence === 1 ? 'Subscriber' : 'Subscribers';
            case 'instagram':
                return influence === 1 ? 'Follower' : 'Followers';
            case 'rss':
                return '';
            case 'google_ozmosys':
                return '';
            case 'web':
                return '';
            default:
                return '';
        }
    };


    const toggleAccordion = async() => {
        try {
            setSubmitting(true);
            toggleIsOpen();
            const params = {
                entityId: activeEntityId,
                sourceId: source.id,
            };
            await updateSourceIsOpen(params);

            source.isOpen = !source.isOpen;

            setSubmitting(false);
        } catch(err) {
            setSubmitting(false);
            console.log(err);
            if(err.message.length < 150) {
                toast.error(err.message);
                throw err.message;
            }
        }
    };

    const handleNextClick = () => setVisibleArticleRange(prevState => prevState + 5);
    const handlePreviousClick = () => setVisibleArticleRange(prevState => prevState - 5);

    return (
        <div className="article-list-source-block">
            <div className="article-list-source-block__header">
                {submitting ?
                    <div className="flex-centered" style={{width: '50px', height: '50px'}}>
                        <Spinner style={{ width: '20px', height: '20px', borderWidth: '3px' }} />
                    </div>
                    :
                    <div className="article-list-source-block__accordion-toggle"
                         onClick={toggleAccordion}>
                        {isOpen ?
                            <i className="fas fa-caret-down"/>
                            :
                            <i className="fas fa-caret-right"/>
                        }
                    </div>
                }
                <div className="article-list-source-block__icon">{getSourceIcon(source.type)}</div>
                <div className="article-list-source-block__content">
                    <div className="article-list-source-block__title">{textTruncateByLength(source.sourceName, 50)}</div>
                    {
                        (source.type !== 'twitter' ||
                            (source.type === 'twitter' && (source.twitterPageId || source.pageId))
                        ) &&
                        <div className="article-list-source-block__info">
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={source.url}
                                style={{
                                    textDecoration: 'underline',
                                }}
                            >{textTruncateByLength(source.sourceName, 50)}</a>
                            {handleInfluenceDisplay()}
                        </div>
                    }
                </div>
            </div>

            {isOpen &&
            <>
                <div className="article-list-source-block__body">
                    {visibleNews && visibleNews.length ?
                        visibleNews.slice(visibleArticleRange - 5, visibleArticleRange).map(article => {
                            return <Article article={article} blockType={source.type} source={source} key={article.id} />;
                        })
                        :
                        <div style={{padding: '10px 65px'}}>No news posts were found for the last 30 days</div>

                    }
                </div>
                <div className="article-list-source-block__footer d-flex justify-content-between">
                    {(visibleNews && visibleArticleRange - 5 > 0) ?
                        <Button onClick={handlePreviousClick}
                                className="pagination-btn btn-secondary mb-2">
                            <i className="fas fa-caret-left"/>
                            &nbsp;Previous
                        </Button> : <div/>
                    }
                    {(visibleNews && visibleArticleRange < visibleNews.length) ?
                        <Button onClick={handleNextClick}
                                className="pagination-btn btn-secondary mb-2">
                            Next&nbsp;
                            <i className="fas fa-caret-right"/>
                        </Button> : <div/>}
                </div>
            </>
            }
        </div>
    );
};

export default SourceBlock;
